import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function AnyaHistoryMenuIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.75 8C4.33579 8 4 8.33579 4 8.75C4 9.16421 4.33579 9.5 4.75 9.5H10.25C10.6642 9.5 11 9.16421 11 8.75C11 8.33579 10.6642 8 10.25 8H4.75ZM4 13C4 12.5858 4.33579 12.25 4.75 12.25H13.25C13.6642 12.25 14 12.5858 14 13C14 13.4142 13.6642 13.75 13.25 13.75H4.75C4.33579 13.75 4 13.4142 4 13ZM4 17.25C4 16.8358 4.33579 16.5 4.75 16.5H16.25C16.6642 16.5 17 16.8358 17 17.25C17 17.6642 16.6642 18 16.25 18H4.75C4.33579 18 4 17.6642 4 17.25Z"
        fill="#384150"
      />
    </svg>
  );
};
